import {createSlice} from '@reduxjs/toolkit';
import { TFeePaymentType } from '../../models/registration.model';

interface selectedPlanFeePaymentType {
   feePaymentType : TFeePaymentType | null;
}
const initialState: selectedPlanFeePaymentType = {
    feePaymentType: null,
};

export const subscriptionPlanSlice = createSlice({
    name: 'subscriptionPlan',
    initialState,
    reducers: {
        setSubscriptionPlanId: (state: selectedPlanFeePaymentType, action: any) => {
            state.feePaymentType = action.payload;
        },
    },
});

export const {setSubscriptionPlanId}: any = subscriptionPlanSlice.actions;

export default subscriptionPlanSlice.reducer;
